import { createApp } from 'vue'

import App from './App.vue'
import router from "./router";
import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from 'vue3-scroll-spy';

import { vMaska } from "maska"
import i18n from "./i18n"

import BootstrapVueNext from 'bootstrap-vue-next'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import "@/assets/scss/app.scss";
import "@vueform/multiselect/themes/default.css"

// PINIA
import pinia from '@/state/pinia'

import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';

import 'leaflet/dist/leaflet.css';

import { LoadingPlugin } from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import moment from 'moment';
require('moment/locale/pt-br');

import clientConfig from '@/client-config.json';

const app =
  createApp(App)
  .use(pinia)
  .use(router)
  .use(require('vue-chartist'))
  .use(BootstrapVueNext)
  .use(VueApexCharts)
  .use(vClickOutside)
  .use(i18n)
  .use(LoadingPlugin, {
    color: '#27377f',
    width: 40,
    height: 40,
    canCancel: false,
  })
  .use(ToastPlugin, {
    position: 'bottom-right'
  })
  .use(registerScrollSpy)
  .directive("maska", vMaska)
  .provide('moment', moment)

app.config.globalProperties.$clientConfig = clientConfig;
document.title = clientConfig.APP_TITLE;
app.mount('#app')
